module.exports = __webpack_public_path__ + "img/corn_grain.be5030ca.webp";